import {
  useEvents
} from "./chunk-TFRVQL75.mjs";
import {
  HelpCenterEvents
} from "./chunk-AOTFDLGI.mjs";
import {
  useLayoutContext
} from "./chunk-HFINPXUM.mjs";

// src/internal/components/help-center-panel/help-center-footer.tsx
import { useCallback } from "react";
import { useAnalytics } from "@clara/events";
import { Button } from "@clara/button";
import { useT } from "@clara/locale";
import { ZendeskButton } from "@clara/zendesk";
import { jsx } from "react/jsx-runtime";
var HelpCenterFooter = () => {
  const { sidePanel } = useLayoutContext();
  const { t } = useT("common");
  const analytics = useAnalytics();
  const { eventData } = useEvents();
  const onButtonClick = useCallback(() => {
    sidePanel.onClose();
    analytics.track(HelpCenterEvents.EXPERIENCE_HELPERSIDE_CHAT_OPEN, {
      ...eventData,
      action: "open_chat"
    });
  }, [analytics, eventData, sidePanel]);
  return /* @__PURE__ */ jsx(
    ZendeskButton,
    {
      onClick: onButtonClick,
      render: (props) => /* @__PURE__ */ jsx(Button, { variant: "secondary", ...props, children: t("helpCenter.panel.button.chat") })
    }
  );
};

export {
  HelpCenterFooter
};
